import { Component, signal, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { Subject, debounceTime } from 'rxjs';
import { ApplicationApiService, ProjectDto } from 'src/app/services/application-api.service';
import { MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { RoadmapAttachmentsComponent } from '../roadmap-goals/roadmap-attachments/roadmap-attachments.component';

@Component({
  selector: 'app-search-project',
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressBarModule,
    MatTableModule,
    MatSortModule,
    MatDialogModule,
    DatePipe,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './search-project.component.html',
  styleUrl: './search-project.component.scss'
})
export class SearchProjectComponent {
  readonly searchSubject = new Subject<string>();
  readonly isLoading = signal(false);
  readonly hasSearched = signal(false);
  readonly showMore = signal(false);
  readonly apiService = inject(ApplicationApiService);
  readonly displayedColumns = ['projectName','projectNumber'];
  readonly dataSource = signal(new MatTableDataSource<ProjectDto>());
  readonly selectedProject = signal<ProjectDto | null>(null);
  searchTerm = '';
  readonly dialogRef = inject(MatDialogRef<RoadmapAttachmentsComponent>);

  constructor() {
    this.searchSubject.pipe(
      debounceTime(500),
      takeUntilDestroyed()
    ).subscribe(searchTerm => {
      this.performSearch(searchTerm);
    });
  }

  public debounceSearch(searchTerm: string): void {
    this.searchSubject.next(searchTerm);
  }

  private performSearch(searchTerm: string): void {
    if (searchTerm.length < 3) {
      this.dataSource().data = [];
      this.hasSearched.set(false);
      return;
    }
    this.isLoading.set(true);
    this.apiService.apiProjectsProjectSearch(searchTerm).subscribe({
      next: (results: ProjectDto[]) => {
        this.dataSource().data = results;
        this.isLoading.set(false);
        this.hasSearched.set(true);
      }
    });
  }

  public onProjectSelect(projectNumber: string): void {
    this.selectedProject.set(this.dataSource().data.find(p => p.projectNumber === projectNumber) || null);
    this.showMore.set(true);
  }

  public onBackClick(): void {
    this.showMore.set(false);
  }

  public onProjectSelectClick(): void {
    this.dialogRef.close(this.selectedProject());
  }
}
